const host = window.location.host
const parts = host.split('.')

import { createApp, getCurrentInstance } from "vue";
import App from "./App";
import router from "./router";
import router2 from "./router/index_user";
import router3 from "./router/index_pos";
import store from "./store";
import axios from "axios";
import dayjs from 'dayjs';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Vue3Geolocation from 'vue3-geolocation';
import mitt from 'mitt';
import VueSimpleAlert from "vue3-simple-alert-next";
import LogRocket from 'logrocket';
// 세션 리플레이는 운영 빌드에서만 활성화 (dev에서는 끄기)
if (process.env.NODE_ENV === 'production') {
    try {
        LogRocket.init('hands/hands-app-order', {
            dom: {
                // 모든 입력 필드 값(비밀번호·카드번호 등) 마스킹
                inputSanitizer: true,
            },
            network: {
                // 요청 헤더의 인증 토큰 제거
                requestSanitizer: request => {
                    if (request.headers && request.headers['authorization']) {
                        request.headers['authorization'] = '';
                    }
                    return request;
                },
                // 응답 본문의 토큰 등 민감 정보 제거
                responseSanitizer: response => {
                    if (response.body && response.body.token) {
                        response.body.token = '**REDACTED**';
                    }
                    return response;
                },
            },
        });
        if (localStorage.getItem('uid')) {
            // 아이디(로그인 ID)를 기준으로 식별, 이름은 부가 정보로 표시
            LogRocket.identify(localStorage.getItem('uid'), {
                name: localStorage.getItem('name')
            });
        }
    } catch (e) {
        console.warn('LogRocket init failed:', e);
    }
}

axios.defaults.paramsSerializer = function(paramObj) {
    const params = new URLSearchParams()
    for (const key in paramObj) {
        params.append(key, paramObj[key])
    }

    return params.toString()
}
axios.defaults.timeout = 100000;
//axios.defaults.baseURL = "http://localhost:8080";
axios.defaults.baseURL = window.location.protocol + "//"+window.location.host;
axios.defaults.port = ":"+window.location.port;
// 캐싱 방지
axios.defaults.headers.get['Cache-Control'] = 'no-cache';
axios.defaults.headers.get['Pragma'] = 'no-cache';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;

axios.interceptors.request.use((request) => {

    if(request.port != ":8000" && request.port != ":8100"){
        if(request.url.indexOf("/api/") > -1){
        //spring-boot api 호출의 경우
            request.baseURL = "http://handsorder.cafe24.com";
            request.url = request.url.replace("/api","");
        }else if(request.url.indexOf("/pos-api/") > -1){
        // 구 핸즈앱 api 호출
            request.baseURL = window.location.protocol+"//mng.handsnetwork.com";
            request.url = request.url.replace("/pos-api","/rest_free");
        }else if(request.url.indexOf("/app-api/") > -1){
        // 운영
            request.baseURL = "https://app.handsnetwork.com";
            request.url = request.url.replace("/app-api","/rest_free");
        }
    }

    request.headers.authorization = localStorage.getItem('authorization');

    return request;
})

// ===== 권한 오류(토큰 미반영) 자동 복구 =====
// 토큰을 발급/검증하는 부트스트랩 요청은 재시도 대상에서 제외 (자기 자신을 기다리는 데드락 방지)
function isAuthBootstrapUrl(url) {
  console.log("11");
    return /chkToken|chkDBToken|getUserLogin|\/login/i.test(url || '');
}

// 보낸 토큰과 다른(새로 생성/갱신된) 토큰이 localStorage에 들어올 때까지 대기
function waitForFreshToken(sentToken, maxWaitMs = 5000, intervalMs = 50) {
  console.log("22");
    return new Promise((resolve) => {
        const now = localStorage.getItem('authorization');
        if (now && now !== sentToken) return resolve(now);
        const start = Date.now();
        const timer = setInterval(() => {
            const token = localStorage.getItem('authorization');
            if ((token && token !== sentToken) || Date.now() - start >= maxWaitMs) {
                clearInterval(timer);
                resolve(localStorage.getItem('authorization'));
            }
        }, intervalMs);
    });
}

// 권한 오류(err 500 / err_msg "권한이 없습니다")면 토큰 생성 대기 후 1회 재호출, 아니면 null 반환
async function retryOnPermError(data, config) {
  console.log("33");
    config = config || {};
    const isPermErr = data && data.err == 500 && data.err_msg && String(data.err_msg).indexOf('권한이 없습니다') > -1;
    if (!isPermErr || config._tokenRetried || isAuthBootstrapUrl(config.url)) {
        return null;
    }
    const sentToken = config.headers ? config.headers.authorization : null;
    // 토큰이 생성/갱신될 때까지 대기
    const freshToken = await waitForFreshToken(sentToken);
    // 새 토큰이 확보됐을 때만 1회 재호출 (없거나 동일하면 실제 권한 오류)
    if (freshToken && freshToken !== sentToken) {
        config._tokenRetried = true;
        return axios(config); // 요청 인터셉터가 새 토큰을 다시 부착해 재호출
    }
    return null;
}

axios.interceptors.response.use(
    // HTTP 200 + 본문 err 500 케이스
    async (response) => {
        const retried = await retryOnPermError(response.data, response.config);
        return retried || response;
    },
    // HTTP 500 등으로 reject되는 케이스
    async (error) => {
        if (error.response) {
            const retried = await retryOnPermError(error.response.data, error.config);
            if (retried) return retried;
        }
        return Promise.reject(error);
    }
);

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.component('Datepicker', Datepicker);
const emitter = mitt();
app.config.globalProperties.emitter = emitter;

var setRouter;
if(parts[0] == "mng"){
    setRouter = router;
}else if(parts[0] == "app"){
    setRouter = router2;
}else if(parts[0] == "pos"){
    setRouter = router3;
}
app.use(dayjs);
app.use(Vue3Geolocation);
app.use(VueSimpleAlert, { confirmButtonText : "확인", cancelButtonText : "취소" });

window.app = app.use(store)
            .use(setRouter)
            .mount("#app");

app.config.globalProperties.$filters = {
    dateformat(value) {
        if(!value) return '';

        if(typeof value === 'string'){
            return value.substring(0,10);
        }
        return '';
    },
    numberformat(value){
        if(!value) return 0;
        return Number(value).toLocaleString();
    },
    getDate(d){
        var d = new Date(d),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    },
    getMonth(d){
        var d = new Date(d),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month].join('-');
    }
}
//window.app = app;
